module.exports = __webpack_public_path__ + "static/media/icone-saude.15d2620e.png";